<template>
  <div class="solutions__item" v-bind:class="{'solutions__item--xl': number === 0}">
    <div class="solutions-card" v-bind:class="{'solutions-card--xl': number === 0}">
      <slot name="product"
            :info="info"
            :quntity="quantity"
            :link="link"
            :moduleCart="moduleCart"
      ></slot>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "ProductCard",
  props: [
    "info",
    "number",
  ],
  data() {
    return {
      quantity: 1,
      link: ""
    };
  },
  computed: {
    ...mapState([
      "moduleCart"
    ]),
  },
  methods: {},
  created() {
    if (this.info.URL) {
      this.link = this.info.URL;
    }
    if (this.info.DETAIL_PAGE_URL) {
      this.link = this.info.DETAIL_PAGE_URL;
    }
  }
};
</script>